import { Box, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../../ricos-context";
import { SWATCHES } from "../../data-hooks";
import { NewColorSwatches } from "../new-color-swatches";
import { PredefinedSwatches } from "../predefined-swatches";
import classes from "./swatch-color-picker-scss";
const SwatchColorPicker = ({
  currentColor,
  userColors,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement("div", { className: classes.content }, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP2" }, /* @__PURE__ */ React.createElement(
    PredefinedSwatches,
    {
      currentColor,
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd
    }
  ), /* @__PURE__ */ React.createElement(Text, { secondary: true, light: true, size: "small", weight: "normal" }, t("Color_Picker_CustomColor_Title")), /* @__PURE__ */ React.createElement(
    NewColorSwatches,
    {
      colors: userColors,
      selectedColor: currentColor?.toUpperCase(),
      onAddClick,
      onColorSelected,
      onColorPreviewStart,
      onColorPreviewEnd,
      dataHook: SWATCHES
    }
  )));
};
export {
  SwatchColorPicker
};
//# sourceMappingURL=swatch-color-picker.js.map
